import React, { useEffect } from 'react';
import './welcome-help-modal.css';
import logoImage from '@assets/svg/normal/logo-addict.svg';

const WelcomeHelpModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    const handleEscKey = (event) => {
      if (isOpen && event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEscKey);

    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, [onClose, isOpen]);

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div 
      className="modal-help-overlay" 
      onClick={onClose} 
      style={{ display: isOpen ? 'flex' : 'none' }}
    >
      <div className="modal-help-content" onClick={handleContentClick}>
        <button className="close-welcome-button" onClick={onClose}>
            X
        </button>
        <div className="modal-help-header">
          <h2 className="modal-help-title"><span>LES 3 BONNES RAISONS<br/>DE CHOISIR L'ABONNEMENT</span></h2>
        </div>
        
        <img src={logoImage} alt="Addict" className="addict-logo" />
        
        <div className="modal-help-body">
          <div className="reason-item">
            <div className="reason-title">
              <span className="reason-number">1.</span> Un style impeccable toute l'année
            </div>
            <p className="reason-description">
              Avec des rendez-vous réguliers inclus, vous pouvez entretenir vos cheveux et/ou barbe garantissant un look toujours au top.
            </p>
          </div>
          
          <div className="reason-item">
            <div className="reason-title">
              <span className="reason-number">2.</span> Une solution économique et pratique
            </div>
            <p className="reason-description">
              Un abonnement est souvent moins cher que des rendez-vous à l'unité. En plus, il simplifie votre budget beauté grâce à un tarif prévisible et avantageux.
            </p>
          </div>
          
          <div className="reason-item">
            <div className="reason-title">
              <span className="reason-number">3.</span> Des remises sur les extras
            </div>
            <p className="reason-description">
              Bénéficiez de -20% sur nos prestations à la carte, et -10% sur les produits.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeHelpModal;